exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-status-indicator-simple-demo .status-indicator[data-v-103b8023]{margin:10px}", ""]);

// exports
